import React from 'react'

export default ({ color = '#DC5959', height = '12px', width = '12px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.238966 10.556C-0.0734461 10.8684 -0.0883229 11.4263 0.246405 11.7536C0.573694 12.0809 1.13157 12.0734 1.44399 11.761L5.99628 7.2013L10.556 11.761C10.8759 12.0809 11.4263 12.0809 11.7536 11.7536C12.0734 11.4189 12.0809 10.8759 11.7536 10.556L7.2013 5.99628L11.7536 1.44399C12.0809 1.12413 12.0809 0.573694 11.7536 0.246405C11.4189 -0.0734461 10.8759 -0.0808845 10.556 0.238966L5.99628 4.7987L1.44399 0.238966C1.13157 -0.0734461 0.566256 -0.0883229 0.246405 0.246405C-0.0808845 0.573694 -0.0734461 1.13157 0.238966 1.44399L4.7987 5.99628L0.238966 10.556Z"
      fill={color}
    />
  </svg>
)
